export default {"src":"/_next/static/media/logo-white.39b62c1e.svg","height":600,"width":2000,"blurWidth":0,"blurHeight":0};